import React, { useMemo } from 'react'
import { useTableService } from '@hooks/useTableService'
import { getCallRecordList, exportCallRecordList } from '@services/customer'
import Card from 'antd/lib/card/Card'
import { CommonFilters, TableDownload, UserAvatar, ReplayRecord } from '@components'
import { callRecordFilterItems } from 'src/components/CommonFilters/configs'
import { ConfigTableHeader } from 'src/components/ConfigTableHeader'
import { Table, TableProps } from 'antd'
import { CallRecordListFilter, needTotalEnum, sortTypeEnum, CallRecordListItem } from '@types'
import { useTableColumn, TableColumnProps } from '@hooks'
import { antdSortMap } from '@configs/map'
import { Link } from 'react-router-dom'
import { trimStr, handleCallRecord, ExpandCallRecordDataType } from '@library'
import { getSortOrder, getTableXwidth, TableIdEnum } from '@configs/table'
type CallRecordData = CallRecordListItem & ExpandCallRecordDataType
const initFilter: CallRecordListFilter = {
  page: 1,
  pageSize: 10,
  needTotal: needTotalEnum.LIST,
  sort: 'createTime',
  sortType: sortTypeEnum.DESC,
}
export default function QidianCallRecord () {
  const {
    loading,
    list,
    pagination,
    filter,
    setFilter,
    resetFilter,
    rowKey,
  } = useTableService(getCallRecordList, initFilter, '获取通话记录失败')
  const columns: TableColumnProps<CallRecordData>[] = useMemo(() => [
    {
      title: '记录生成时间',
      dataIndex: 'createTime',
      width: 180,
      fixed: true,
      sorter: true,
      sortOrder: filter.sort === 'createTime' ? antdSortMap[filter.sortType] : undefined,
    },
    {
      title: '客户名称',
      dataIndex: 'customerName',
      width: 280,
      fixed: true,
      render: (name, record) => (
        <Link target="_blank" to={`/customer/${record.customerId}?from=${encodeURIComponent(window.location.pathname)}`}>
          {trimStr(name, '-')}
        </Link>),
    },
    { title: '主叫号码', dataIndex: 'callNumber', width: 180 },
    { title: '被叫号码', dataIndex: 'phone', width: 180 },
    { title: '通话结果', dataIndex: 'failReasonText', width: 180 },
    {
      title: '通话开始时间',
      dataIndex: 'callBeginTime',
      width: 180,
      sorter: true,
      sortOrder: filter.sort === 'callBeginTime' ? antdSortMap[filter.sortType] : undefined,
    },
    {
      title: '通话结束时间',
      dataIndex: 'callEndTime',
      width: 180,
      sorter: true,
      sortOrder: filter.sort === 'callEndTime' ? antdSortMap[filter.sortType] : undefined,
    },
    {
      title: '通话时长',
      dataIndex: 'durationText',
      width: 120,
    },
    { title: '跟进人', dataIndex: 'salesName', width: 220, render: value => <UserAvatar salesName={value} /> },
    { title: '满意度', dataIndex: 'satisfactionResultText', width: 120 },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 120,
      render: (formItem, item) => {
        return (
          <ReplayRecord
            disabled={item.disabled}
            playTips={item.playTips}
            logId={item?.callId}
            title={`与${item?.customerName}的通话录音`}
            key={item?.callId}
          />
        )
      },
    },
  ], [filter.sort, filter.sortType])
  const [columnConfigs, columnProps, forceRequest] = useTableColumn(TableIdEnum.CALL_RECORD, columns, ['actions', 'customerName'])
  const callRecordList = useMemo<CallRecordData[]>(() => handleCallRecord(list), [list])

  const tableXWidth = useMemo(() => getTableXwidth(columnProps), [columnProps])
  const onTableChange: TableProps<CallRecordListItem>['onChange'] = (pagination, filters, sorter) => {
    const sort = getSortOrder<CallRecordListFilter>(sorter)
    setFilter(sort)
  }
  return (
    <>
      <Card className="mt20 mb20">
        <CommonFilters
          className="custom-Label"
          itemList={callRecordFilterItems}
          onSubmit={filter => setFilter({ ...filter, page: 1 })}
          onReset={() => resetFilter(initFilter)}
        />
      </Card>
      <Card>
        <ConfigTableHeader columnConfigs={columnConfigs} tableId={TableIdEnum.CALL_RECORD} onSuccess={forceRequest} />
        <TableDownload className="ml20" exportMethod={exportCallRecordList} filter={filter} />
        <Table
          style={{ maxWidth: tableXWidth + 'px' }}
          tableLayout="fixed"
          className="mt20"
          loading={loading}
          pagination={pagination}
          scroll={{ x: tableXWidth }}
          rowKey={rowKey}
          dataSource={callRecordList}
          columns={columnProps}
          onChange={onTableChange}
        />
      </Card>
    </>
  )
}
